import riceJpg from "../../../../images/ricejpg.jpg";

export const riceData = [
  {
    name: "Plain Rice",
    image: riceJpg,
    price: "40.00",
    description: "chicken,BBQ sauce,tomato",
  },

  {
    name: "Red Rice",
    image: riceJpg,
    price: "130.00",
    description: "beef patty, BBQ sauce,",
  },
  {
    name: "Rice with carrot and pees",
    price: "150.00",
    deletedprice: ".200",
    description: "cheese,Naga,cheese,Naga,",
  },
  {
    name: "Rice with carrot and pees",
    image: riceJpg,
    price: "15.00",
    deletedprice: ".200",
    description: "cheese,Naga",
  },
  {
    name: "Blue rice",
    image: riceJpg,
    price: "15.50",
    deletedprice: ".20",
    description: "cheese,Naga",
  },
];
